"use client";

import React, { useRef } from "react";
import { ContainerProp } from "../../../global";
import Image from "next/image";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import { useGSAP } from "@gsap/react";

type SingleContainerProp = Omit<
    ContainerProp,
    "serviceName" | "header" | "para" | "description"
> & {
    imageSrc: string;
};

gsap.registerPlugin(ScrollTrigger);

export default function SingleImageContainer({
    imageSrc,
    altText,
    className,
}: SingleContainerProp) {
    const containerRef = useRef(null);
    const imgRef = useRef(null);

    useGSAP(
        () => {
            let imageTl = gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top center",
                    toggleActions: "play none none reverse",
                },
            });

            imageTl.to(imgRef.current, { opacity: 1, stagger: 0.3, y: 0 });
        },
        { scope: containerRef }
    );
    return (
        <section className=" full-section bg-lightGrey py-12 md:py-0 ">
            <div className={"" + className} ref={containerRef}>
                <Image
                    src={imageSrc}
                    width={460}
                    height={460}
                    alt={altText || ""}
                    className=" relative w-2/3 sm:w-1/2 md:w-2/5 h-auto object-contain z-10 opacity-0 translate-y-8"
                    ref={imgRef}
                    loading="lazy"
                />
            </div>
        </section>
    );
}
